export default [
    {
        name: 'role.name',
        title: 'Role <i class="arrow"></i>',
        sortField: 'role.name',
        propName: 'role'
    },
    {
        name: 'address.companyName',
        title: 'Company <i class="arrow"></i>',
        sortField: 'address.companyName',
        propName: 'companyName'
    },
    {
        name: 'person.firstName',
        title: 'First name <i class="arrow"></i>',
        sortField: 'person.firstName',
        propName: 'firstName'
    },
    {
        name: 'person.lastName',
        title: 'Last name <i class="arrow"></i>',
        sortField: 'person.lastName',
        propName: 'lastName'
    },
    'actions'
];